import React from "react";
import "./Header.css";

import nameLogo from "../../assets/Images/footer-1.svg";
import Wave from "../../assets/Videos/Wave.mp4";

const Header = () => {
    return (
        <header className="home-hero">
            <div className="home-hero__background">
                <video
                    className="home-hero__video"
                    src={Wave}
                    autoPlay
                    loop
                    muted
                    playsInline
                />

                <div className="home-hero__overlay" />

                <div className="home-hero__contentWrapper">
                    <div className="home-hero__content">
                        <p className="home-hero__subtitle">
                            Welcome to
                        </p>

                        <img
                            src={nameLogo}
                            alt="Eupraxia Clinical"
                            className="home-hero__logo"
                        />

                        <p className="home-hero__tagline">
                            Delivering Excellence in Clinical Research.
                        </p>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;